import { render, staticRenderFns } from "./AccountLoginV3.vue?vue&type=template&id=96734ff2&"
import script from "./AccountLoginV3.vue?vue&type=script&lang=js&"
export * from "./AccountLoginV3.vue?vue&type=script&lang=js&"
import style0 from "./AccountLoginV3.vue?vue&type=style&index=0&id=96734ff2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports